import React from "react";
// After
import { createRoot } from "react-dom/client";
import App from "./App";
import "./input.css";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
